import React, { useRef, useState, useEffect } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import ManageAdmin from "./manageAdmin";
import { apiservice } from "../service/api";

const { width, height } = Dimensions.get("window");

const addUser = () => {
  const data1 = [{ data1 }, { data1 }, { data1 }, { data1 }];
  const [page, setpage] = useState(0);

  const placeholder1 = {
    label: "",
    value: null,
    color: "#3D6B99",
  };
  const [items1, setItems1] = useState([
    { label: "SuperAdmin", value: "SUPERADMIN" },
    { label: "Admin", value: "ADMIN" },
  ]);
  const placeholder2 = {
    label: "",
    value: null,
    color: "#3D6B99",
  };
  const [items2, setItems2] = useState([]);

  const [body, setBody] = useState({
    Type: "ADMIN",
    fullname: "",
    username: "",
    password: "",
    image_profile: "https://api.cquiz.app/api/image/get/user",
    email: "",
    tel_number: "",
  });

  const [validate, setValidate] = useState({
    fullname: false,
    username: false,
    password: false,
    email: false,
    tel_number: false,
  });

  const [items, setItem] = useState({
    name: "",
    theme: {
      header: "#FFF",
      button: "#FFF",
      text: "#FFF",
      icon: "#FFF",
      calender: "#FFF",
      title: "#FFF",
    },
    logo: "https://api.cquiz.app/api/image/get/user",
  });

  async function createUniversity() {
    if (body.fullname.length == 0) {
      setValidate((val) => ({ ...val, fullname: true }));
    }
    if (body.username.length == 0) {
      setValidate((val) => ({ ...val, username: true }));
    }
    if (body.password.length < 8) {
      setValidate((val) => ({ ...val, password: true }));
    }
    if (body.email.length == 0) {
      setValidate((val) => ({ ...val, email: true }));
    }
    if (body.tel_number.length == 0) {
      setValidate((val) => ({ ...val, tel_number: true }));
    }
    if (
      body.fullname.length != 0 &&
      body.username.length != 0 &&
      body.password.length != 0 &&
      body.email.length != 0 &&
      body.tel_number.length != 0
    ) {
      const res = await apiservice({
        path: "/authen/createadmin",
        method: "post",
        body,
      });
      if (res.status == 200) {
        setpage(1);
      }
    }
  }

  async function deleteUniversity(params) {
    const res = await apiservice({
      path: "/university/delete/" + params,
      method: "delete",
    });
    if (res.status == 200) {
      getallUniversity();
      setmodalAddUniversity(false);
      setmodal(false);
    }
  }

  async function updateUniversity() {
    const res = await apiservice({
      path: "/university/update",
      method: "put",
      body: items,
    });

    if (res.status == 200) {
      getallUniversity();
      setmodalAddUniversity(false);
      setmodal(false);
      setpage(0);
    }
  }

  async function getallUniversity() {
    const res = await apiservice({
      path: "/university/all",
      method: "get",
    });
    if (res.status == 200) {
      console.log(
        res.data.result.map((itemss) => ({
          ...itemss,
          label: itemss.name,
          value: itemss.id.toString(),
        }))
      );
      setItems2(
        res.data.result.map((itemss) => ({
          ...itemss,
          label: itemss.name,
          value: itemss.id.toString(),
        }))
      );
    }
  }

  useEffect(() => {
    getallUniversity();
  }, []);

  if (items2.length == 0) {
    return <View />;
  }

  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Regular",
              color: "#202020",
            }}
          >
            เพิ่มผู้ดูแล
          </Text>

          <View
            style={{
              borderWidth: 0.5,
              borderColor: "#002377",
              width: width * 0.591,
              margin: 30,
            }}
          ></View>

          <View style={{ width: width * 0.591, height: height * 0.546 }}>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>ชื่อผู้ดูแล</Text>
              <TextInput
                value={body.fullname}
                onChangeText={(text) => {
                  setBody((val) => ({ ...val, fullname: text }));
                }}
                style={styles.TextInput}
              />
            </View>
            {validate.fullname && (
              <View
                style={[
                  styles.Boxarea,
                  { height: null, marginTop: -10, marginBottom: 10 },
                ]}
              >
                <View />
                <Text
                  style={[
                    styles.Text20,
                    {
                      color: "#ff0000",
                      fontSize: 16,
                    },
                  ]}
                >
                  ชื่อผู้ดูแลต้องมีตัวอักษรอย่างน้อย 0 ตัวอักษร
                </Text>
              </View>
            )}
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>ระดับ</Text>

              <RNPickerSelect
                placeholder={placeholder1}
                style={{
                  inputWeb: {
                    width: width * 0.182,
                    height: height * 0.037,
                    borderWidth: 0.5,
                    borderColor: "#00237740",
                    borderRadius: 5,
                    paddingLeft: 10,
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                  },
                }}
                onValueChange={(value) =>
                  setBody((val) => ({ ...val, Type: value }))
                }
                value={body.Type}
                items={items1}
              />
            </View>
            {body.Type == "ADMIN" && (
              <View style={styles.Boxarea}>
                {/* <Text style={styles.Text20}>มหาวิทยาลัย</Text> */}
                <Text style={styles.Text20}>องค์กร</Text>
                <RNPickerSelect
                  placeholder={placeholder2}
                  style={{
                    inputWeb: {
                      width: width * 0.182,
                      height: height * 0.037,
                      borderWidth: 0.5,
                      borderColor: "#00237740",
                      borderRadius: 5,
                      paddingLeft: 10,
                      fontSize: 18,
                      fontFamily: "Prompt-Regular",
                    },
                  }}
                  onValueChange={(value) =>
                    setBody((val) => ({ ...val, university_id: value }))
                  }
                  value={body.university_id}
                  items={items2}
                />
              </View>
            )}
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>ชื่อผู้ใช้งาน(username)</Text>
              <TextInput
                value={body.username}
                onChangeText={(text) => {
                  setBody((val) => ({ ...val, username: text }));
                }}
                style={styles.TextInput}
              />
            </View>
            {validate.username && (
              <View
                style={[
                  styles.Boxarea,
                  { height: null, marginTop: -10, marginBottom: 10 },
                ]}
              >
                <View />
                <Text
                  style={[
                    styles.Text20,
                    {
                      color: "#ff0000",
                      fontSize: 16,
                    },
                  ]}
                >
                  ชื่อผู้ใช้ต้องมีตัวอักษรอย่างน้อย 0 ตัวอักษร
                </Text>
              </View>
            )}
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>รหัสผ่าน</Text>
              <TextInput
                secureTextEntry
                value={body.password}
                onChangeText={(text) => {
                  setBody((val) => ({ ...val, password: text }));
                }}
                style={styles.TextInput}
              />
            </View>
            {validate.password && (
              <View
                style={[
                  styles.Boxarea,
                  { height: null, marginTop: -10, marginBottom: 10 },
                ]}
              >
                <View />
                <Text
                  style={[
                    styles.Text20,
                    {
                      color: "#ff0000",
                      fontSize: 16,
                    },
                  ]}
                >
                  รหัสผ่านต้องมีตัวอักษรอย่างน้อย 8 ตัวอักษร
                </Text>
              </View>
            )}
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>E-mail</Text>
              <TextInput
                value={body.email}
                onChangeText={(text) => {
                  setBody((val) => ({ ...val, email: text }));
                }}
                style={styles.TextInput}
              />
            </View>
            {validate.email && (
              <View
                style={[
                  styles.Boxarea,
                  { height: null, marginTop: -10, marginBottom: 10 },
                ]}
              >
                <View />
                <Text
                  style={[
                    styles.Text20,
                    {
                      color: "#ff0000",
                      fontSize: 16,
                    },
                  ]}
                >
                  รูปแบบ Email ไม่ถูกต้อง
                </Text>
              </View>
            )}
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>โทรศัพท์</Text>
              <TextInput
                maxLength={10}
                value={body.tel_number}
                onChangeText={(text) => {
                  setBody((val) => ({
                    ...val,
                    tel_number: text.replace(/[^0-9]/g, ""),
                  }));
                }}
                style={styles.TextInput}
              />
            </View>
            {validate.tel_number && (
              <View
                style={[
                  styles.Boxarea,
                  { height: null, marginTop: -10, marginBottom: 10 },
                ]}
              >
                <View />
                <Text
                  style={[
                    styles.Text20,
                    {
                      color: "#ff0000",
                      fontSize: 16,
                    },
                  ]}
                >
                  รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง
                </Text>
              </View>
            )}
            <View style={styles.Boxareabutton}>
              <TouchableOpacity
                onPress={createUniversity}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#69D443",
                  marginRight: 20,
                }}
              >
                <Text style={styles.TextButton}>ยืนยัน</Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => setpage(1)}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#D44343",
                }}
              >
                <Text style={styles.TextButton}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
      {page == 1 && <ManageAdmin />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  Boxareabutton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginTop: 30,
  },
  Text20: { fontSize: 20, fontFamily: "Prompt-Regular" },
  TextInput: {
    width: width * 0.182,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 18,
    fontFamily: "Prompt-Regular",
  },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default addUser;
